var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDelete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.139,
    height: 21.102,
    viewBox: "0 0 17.139 21.102",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_176",
    "data-name": "Group 176",
    transform: "translate(0.003 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M222.892,154.7a.494.494,0,0,0-.494.494v9.34a.494.494,0,1,0,.988,0V155.2A.494.494,0,0,0,222.892,154.7Zm0,0",
    transform: "translate(-211.41 -147.059)",
    fill: "#f601c2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M104.892,154.7a.494.494,0,0,0-.494.494v9.34a.494.494,0,1,0,.988,0V155.2A.494.494,0,0,0,104.892,154.7Zm0,0",
    transform: "translate(-99.242 -147.059)",
    fill: "#f601c2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M1.4,6.281V18.457a2.727,2.727,0,0,0,.725,1.88,2.434,2.434,0,0,0,1.766.763h9.35a2.433,2.433,0,0,0,1.766-.763,2.727,2.727,0,0,0,.725-1.88V6.281a1.888,1.888,0,0,0-.484-3.712h-2.53V1.951A1.941,1.941,0,0,0,10.76,0H6.372A1.941,1.941,0,0,0,4.415,1.951v.618H1.885A1.888,1.888,0,0,0,1.4,6.281ZM13.241,20.112H3.891a1.565,1.565,0,0,1-1.5-1.656V6.324H14.744V18.457a1.565,1.565,0,0,1-1.5,1.656ZM5.4,1.951A.952.952,0,0,1,6.372.987H10.76a.952.952,0,0,1,.969.964v.618H5.4ZM1.885,3.557H15.248a.89.89,0,1,1,0,1.779H1.885a.89.89,0,1,1,0-1.779Zm0,0",
    transform: "translate(0 0)",
    fill: "#5b0596"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M163.892,154.7a.494.494,0,0,0-.494.494v9.34a.494.494,0,0,0,.988,0V155.2A.494.494,0,0,0,163.892,154.7Zm0,0",
    transform: "translate(-155.326 -147.059)",
    fill: "#f601c2"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDelete);
export default __webpack_public_path__ + "static/media/icon-delete.374b69d8b18b2ccf89b1a8ad9422dbcb.svg";
export { ForwardRef as ReactComponent };